__turbopack_context__.v({
  "container": "AlphaSortGrid-module-scss-module__Y5ov9G__container",
  "grid": "AlphaSortGrid-module-scss-module__Y5ov9G__grid",
  "item": "AlphaSortGrid-module-scss-module__Y5ov9G__item",
  "section": "AlphaSortGrid-module-scss-module__Y5ov9G__section",
  "sectionTitle": "AlphaSortGrid-module-scss-module__Y5ov9G__sectionTitle",
  "title": "AlphaSortGrid-module-scss-module__Y5ov9G__title",
});
